import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellText from "ds/components/Table/Row/CellText";
import {
  SharedModuleDataWithSpace,
  SharedModuleDataWithAccount,
} from "views/Account/SharedModulesNew/types";

const SharedModulesTableSharedFromCell = ({
  item: sharedModule,
  ...cellProps
}: TableSimpleCellProps<SharedModuleDataWithSpace | SharedModuleDataWithAccount>) => {
  return (
    <TableSimpleCell {...cellProps} role="rowheader">
      <TableCellText>
        {(() => {
          if ("space" in sharedModule && sharedModule.space) {
            return sharedModule.space.name;
          }
          if ("subdomain" in sharedModule && sharedModule.subdomain) {
            return sharedModule.subdomain;
          }
          return "";
        })()}
      </TableCellText>
    </TableSimpleCell>
  );
};

export default SharedModulesTableSharedFromCell;
